import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';
import translation from 'translation';

const projectBidmanagerRoutes = [
  {
    path: 'bidmanager',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Bid Manager')
      },
      permissions: ['READ_BIDMANAGER_GROUPS']
    },
    children: [
      {
        path: '',
        name: 'projectBidManager',
        component: () => asyncLoadView(import('pages/optimization/bidmanager/BidManagerGroupListPage')),
        props: routeArgsToInt
      },
      {
        path: 'create',
        name: 'bidManagerGroupCreateNew',
        component: () => asyncLoadView(import('pages/optimization/bidmanager/Bidmanager')),
        props: routeArgsToInt
      },
      {
        path: ':bidManagerGroupId(\\d+)',
        name: 'bidManagerGroupDetailsNew',
        component: () => asyncLoadView(import('pages/optimization/bidmanager/Bidmanager')),
        props: routeArgsToInt
      },
      {
        path: ':bidManagerGroupId(\\d+)/history',
        name: 'bidManagerGroupHistoryNew',
        component: wrapLegacyRoute('bidmanagerController', 'groupHistoryNew')
      },
      {
        path: 'old/create/:channelId(\\d+)',
        name: 'bidManagerGroupCreate',
        redirect: {name: 'bidManagerGroupCreateNew'}
      },
      {
        path: 'old/:bidManagerGroupId(\\d+)',
        name: 'bidManagerGroupDetails',
        redirect: {name: 'bidManagerGroupDetailsNew'}
      },
      {
        path: 'old/:bidManagerGroupId(\\d+)/history',
        name: 'bidManagerGroupHistory',
        redirect: {name: 'bidManagerGroupHistoryNew'}
      }
    ]
  }
];

export default projectBidmanagerRoutes;
